var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8121 4.44898L55.0067 2.27101H52.8201H4.93872H2.75231L2.94664 4.44877L7.30421 53.2825L7.4273 54.6619L8.76172 55.032L28.3155 60.4559L28.8498 60.604L29.384 60.4561L48.9919 55.0247L50.3268 54.6549L50.4501 53.2752L54.8121 4.44898Z",
    fill: "#E44D26",
    stroke: "#001E36",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8794 54.377L44.7235 49.9882L48.451 8.26379H28.8794V54.377Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3995 20.2425H28.8793V14.2532H13.8486L13.992 15.86L15.4654 32.3648H28.8793V26.3756H20.9474L20.3995 20.2425ZM21.7505 35.3596H15.7332L16.5729 44.7636L28.8517 48.1692L28.8793 48.1618V41.9304L28.8531 41.9373L22.1773 40.1362L21.7505 35.3596Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8588 32.3648H36.2401L35.5441 40.1325L28.8586 41.9354V48.1664L41.1472 44.7636L41.2373 43.7517L42.6461 27.9839L42.7923 26.3756H28.8588V32.3648ZM28.8588 20.2279V20.2425H43.3377L43.4579 18.8964L43.7311 15.86L43.8743 14.2532H28.8588V20.2279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.5fe93923d1d92a9b4aa0f6b6cdba88eb.svg";
export { ForwardRef as ReactComponent };